

export const mapFormToApi = (form) => ({
  registrationType: form.regtype,
  registrationNo: form.regNumber,
  branch: form.branch,
  isUnRegistered: form.customerAddressIsDeactivate,
  registrationDate: form.consigneePreferredDeliveryFCL,
  validUpto: form.valitedUpTo
});


